import React from "react";
import "swiper/swiper.scss";
import "../../assets/styles/Kv.scss";
import ContentWrapper from "../ContentWrapper";
import Slider from "../parts/Slider";
import Text from "../parts/Text";

export interface KvProps {}

export interface KvState {}

export const Kv = (props: KvProps) => {
  return (
    <section id="kv">
      <ContentWrapper>
        <Text tag="h1" center color="pink">
          Wybierz szablon, który podoba Ci się najbardziej.
          <br className="d-none d-sm-block" />
          To on będzie widoczny na podglądzie.
        </Text>
      </ContentWrapper>
      <Slider />
    </section>
  );
};

export default Kv;
